import React from "react";
import {
  FaTripadvisor,
  FaGoogle,
  FaPlaneDeparture,
  FaShieldAlt,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

type TrustItem = {
  label: string;
  icon: React.ReactNode;
};

const trustItems: TrustItem[] = [
  {
    label: "TripAdvisor",
    icon: <FaTripadvisor className="text-3xl" />,
  },
  {
    label: "Google Reviews",
    icon: <FaGoogle className="text-2xl" />,
  },
  {
    label: "IATA",
    icon: <FaPlaneDeparture className="text-2xl" />,
  },
  {
    label: "SecurePay",
    icon: <FaShieldAlt className="text-2xl" />,
  },
];

const TrustSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

        {/* Heading */}
        <h3 className="font-heading text-2xl font-bold text-brand-dark mb-10">
          {t("Trusted by Global Travelers")}
        </h3>

        {/* Logos */}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
          {trustItems.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-xl font-bold"
            >
              {item.icon}
              {t(item.label)}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TrustSection;
